import clsx from 'clsx';
import type { ReactNode } from 'react';

import { SDSFlexbox, type SDSFlexboxDirection } from '@repo/sds/SDSFlexbox';

import './settings-card.scss';

interface SettingsCardProps {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
  direction?: SDSFlexboxDirection;
  variant?: 'inset' | 'outlined';
}

/**
 * Shared settings surface card with inset shadow and responsive padding.
 */
export function SettingsCard({
  children,
  className,
  dataTestId,
  direction = 'row',
  variant = 'inset',
}: SettingsCardProps) {
  return (
    <SDSFlexbox
      className={clsx('SettingsCard', variant === 'outlined' && 'SettingsCard--outlined', className)}
      dataTestId={dataTestId}
      direction={direction}
      alignItems={direction === 'column' ? 'stretch' : 'center'}
      justifyContent={direction === 'column' ? 'flex-start' : 'space-between'}
      gap="content-default"
      fullWidth
    >
      {children}
    </SDSFlexbox>
  );
}
